// src/index.js

import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
// Comment out React Toastify CSS import temporarily to debug Tailwind issues
// import 'react-toastify/dist/ReactToastify.css'; 
import './index.css'; // Include Tailwind CSS or your preferred styling

const rootElement = document.getElementById('root');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// This check helps with SEO by using hydration when pre-rendered
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <AuthProvider>
      <App />
      <ToastContainer />
    </AuthProvider>
  );
} else {
  const root = createRoot(rootElement);
  root.render(
    <AuthProvider>
      <App />
      <ToastContainer />
    </AuthProvider>
  );
}
